module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin16-3862c4d73810270e02055b53e07e4856.jpg";